module.exports = __webpack_public_path__ + "static/img/two.e5da5e9c.svg";